
import React from "react";
import { Form, Input, Button, Table, Popconfirm, Modal, Tooltip, Space, Breadcrumb } from "antd";
import type { TableColumnsType } from 'antd';
import "./sales_substitution.css";
import withEditableTable, { WithEditableTableProps, DataType } from "../../components/hoc_substitution";
import SubsDataSO from "./subs_data_so";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";

const SalesSubstitution: React.FC<WithEditableTableProps> = ({
    dataSource,
    editingKey,
    form,
    handleSave,
    handleDelete,
    handleAdd,
    handleCellClick,
    handleInputChange,
    handleCustomerNameChange,
    isModalOpen,
    salesMasterData,
    handleOpenModal,
    handleCloseModal,
    handleImport,
    autosaveStatus,
    handleSubmit,
    isFormDisabled,
    handlePrint
}) => {


    const columns: TableColumnsType<DataType> = [
        {
            title: 'No',
            key: 'no',

            render: (text, record, index) => index + 1,
        },
        {
            title: 'Item Invoice',
            dataIndex: 'itemInvoice',
            key: 'itemInvoice',

            onCell: (record: DataType) => ({
                onClick: () => !isFormDisabled && handleCellClick(record),
            }),
            render: (text, record) => {
                if (editingKey === record.key && !isFormDisabled) {
                    return (
                        <Input
                            value={record.itemInvoice}
                            onChange={(e) => handleInputChange(e, record.key, 'itemInvoice')}
                        />
                    );
                }
                return text;
            },

        },
        {
            title: 'Part No Invoice',
            dataIndex: 'partNoInvoice',
            key: 'partNoInvoice',

            onCell: (record: DataType) => ({
                onClick: () => !isFormDisabled && handleCellClick(record),
            }),
            render: (text, record) => {
                if (editingKey === record.key && !isFormDisabled) {
                    return (
                        <Input
                            value={record.partNoInvoice}
                            onChange={(e) => handleInputChange(e, record.key, 'partNoInvoice')}
                        />
                    );
                }
                return text;
            },

        },
        {
            title: 'Item PO',
            dataIndex: 'itemPO',
            key: 'itemPO',

            onCell: (record: DataType) => ({
                onClick: () => !isFormDisabled && handleCellClick(record),
            }),
            render: (text, record) => {
                if (editingKey === record.key && !isFormDisabled) {
                    return (
                        <Input
                            value={record.itemPO}
                            onChange={(e) => handleInputChange(e, record.key, 'itemPO')}
                        />
                    );
                }
                return text;
            },

        },
        {
            title: 'Part No PO',
            dataIndex: 'partNoPO',
            key: 'partNoPO',

            onCell: (record: DataType) => ({
                onClick: () => !isFormDisabled && handleCellClick(record),
            }),
            render: (text, record) => {
                if (editingKey === record.key && !isFormDisabled) {
                    return (
                        <Input
                            value={record.partNoPO}
                            onChange={(e) => handleInputChange(e, record.key, 'partNoPO')}
                        />
                    );
                }
                return text;
            },

        },

        {
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                const editable = record.key === editingKey;
                if (editable) {
                    return (
                        <Button onClick={() => handleSave()} type="primary" disabled={isFormDisabled}>
                            Save
                        </Button>
                    );
                }
                return (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)} disabled={isFormDisabled}>
                        <Button danger disabled={isFormDisabled}>Delete</Button>
                    </Popconfirm>
                );
            },
        },

    ];


    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="ds45d">
                <div className="gjs-grid-column" id="rf21f">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_subs",
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Data Subs</span>
                                    </>
                                ),
                            },
                            {
                                title: "Sales Substitution",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="xd8sj">
                <div className="gjs-grid-column" id="we42jd">
                    <Button
                        className="pr-button"
                        onClick={handleSubmit}
                        disabled={isFormDisabled}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                    <Button className="pr-button" onClick={handlePrint}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Menyimpan otomatis...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Gagal menyimpan otomatis. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave dihentikan. Isi nama customer untuk memulai.">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Perubahan terakhir telah disimpan.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="idk5">
                <div className="gjs-grid-column" id="i8xi">

                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        initialValues={{ status: 'Draft' }}
                    >

                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px", width: "60%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>

                        <Form.Item
                            label="No Subs"
                            name="no_subs"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>

                        <Form.Item
                            label="Date"
                            name="date"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>

                        <Form.Item
                            label="Cutomer Name"
                            name="customer_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" onChange={handleCustomerNameChange} disabled={isFormDisabled} />
                        </Form.Item>

                        <Form.Item
                            label="NO PO"
                            name="no_po"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Sales"
                            name="sales"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                    </Form>

                </div>
            </div>

            <div className="gjs-grid-row" id="irr8e">
                <div className="gjs-grid-column" id="ixb2i">
                    <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }} disabled={isFormDisabled}>
                        Add a row
                    </Button>
                    <Button type="primary" id="subs_data_so" style={{ marginBottom: 16, marginLeft: 12 }} onClick={handleOpenModal} disabled={isFormDisabled}>
                        Import
                    </Button>
                    <Table
                        bordered
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                    />
                </div>
            </div>
            <Modal
                title="Data SO"
                open={isModalOpen}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <SubsDataSO dataSource={salesMasterData} handleImport={handleImport} />
            </Modal>
        </div>
    );
};

export default withEditableTable(SalesSubstitution);